import { useTranslation } from 'react-i18next';

import EmployeesFilter from '../EmployeesFilter';

export default function EmployeesExternalFilter() {
	const { t } = useTranslation();

	return (
		<EmployeesFilter
			name="isExternal"
			label={t('employees.filters.external.label')}
			single
			search={false}
			options={[
				{
					label: t('employees.filters.external.both'),
					value: '',
				},
				{
					label: t('employees.filters.external.onlyInternal'),
					value: 'NOT isExternal:true',
				},
				{
					label: t('employees.filters.external.onlyExternal'),
					value: 'isExternal:true',
				},
			]}
		/>
	);
}
